import React from "react"
import { useField } from "formik"
import styled from "styled-components"
import { CustomSelect, Option } from "../CustomSelect"

const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  color: ${({ theme }) => theme.primaryText};
`

const ErrorText = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`

interface FormikCustomSelectProps {
  name: string
  label?: string
  options: Option[]
  placeholder?: string
  disabled?: boolean
  width?: string
}

const FormikCustomSelect: React.FC<FormikCustomSelectProps> = ({ label, options, placeholder, disabled, width, ...props }) => {
  const [field, meta, helpers] = useField(props)

  const handleChange = (newVal: string) => {
    helpers.setValue(newVal)
  }

  return (
    <div>
      {label && <Label htmlFor={props.name}>{label}</Label>}
      <CustomSelect options={options} value={field.value} onChange={handleChange} placeholder={placeholder} disabled={disabled} width={width} />
      {/* {meta.touched && meta.error ? <ErrorText>{meta.error}</ErrorText> : null} */}
    </div>
  )
}

export default FormikCustomSelect
